import { service2Data } from "../Data/Data";
import PageHeader from "../Components/PageHeader";
import Section from "../Components/Section";
import useChangeTitle from "../Hooks/useChangeTitle.jsx";

function Service2() {
  useChangeTitle("Service2");
  
  return (
    <>
      <PageHeader heading={service2Data.pageHeader} />
      <Section title={service2Data.section.title} className="py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
          {service2Data.section.items.map((item, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-2xl border border-gray-100"
            >
              {/* Image Section */}
              <div className="overflow-hidden h-48">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>

              {/* Details Section */}
              <div className="p-6">
                <h2 className="text-xl text-center group-hover:text-blue-600 transition-colors font-bold text-gray-800 mb-3">
                  {item.title}
                </h2>
                <p className="text-sm text-center text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}

export default Service2;
